import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const en = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Change language',
      pt: 'Portuguese',
      en: 'English',
      es: 'Spanish',
    },
    servicesSelection: {
      title: 'Select services',
      selectAtLeastOne: 'Select at least one service',
      next: 'Next',
    },
    additionalFields: {
      title: 'Additional Fields',
      back: 'back',
      zipLabel: 'ZIP code',
      phoneLabel: 'Phone',
      emailLabel: 'E-mail',
      next: 'Next',
      zipRequired: 'ZIP code is required!',
      phoneRequired: 'Phone is required!',
      emailRequired: 'E-mail is required!',
    },
    bodyStep: {
      identificationBy: 'Identification by {{validation}}',
      companyLabel: 'Company:',
      userLabel: 'User:',
      signOut: 'Sign out',
      versionLabel: 'Version:',
      apiVersionLabel: 'API Version:',
    },
    camera: {
      title: 'Photo',
      back: 'back',
      clear: 'CLEAR',
      next: 'NEXT',
      uploadImage: 'UPLOAD IMAGE',
      camera: 'CAMERA',
      takePhoto: 'TAKE PHOTO',
    },
    choose: {
      title: 'Select analysis method',
      back: 'back',
      cnhOption: 'Analysis by ID/Passport photo',
      faceOption: 'Analysis by face photo',
    },
    identification: {
      title: 'Personal Information',
      back: 'back',
      nameLabel: 'Full name',
      birthLabel: 'Date of birth',
      documentTypeLabel: 'Document type',
      documentNumberLabel: 'Document number',
      next: 'Next',
      nameRequired: 'Name is required!',
      birthRequired: 'Date of birth is required!',
      documentInvalid: 'Invalid document',
    },
    instructions: {
      title: 'Instructions',
      back: 'back',
      next: 'Next',
      selfie: {
        faceVisible: 'Take a selfie with your face centered and visible',
        goodLighting: 'Find good lighting',
        removeAccessories: 'Remove accessories such as glasses and hats',
        avoidRotation: 'Avoid rotating the device camera',
      },
      document: {
        flatSurface: 'Place the document on a flat surface',
        goodLighting: 'Find good lighting',
        adjustFocus: 'Adjust the focus to ensure quality',
        avoidRotation: 'Avoid rotating the device camera',
      },
    },
    result: {
      title: 'Result',
      fullName: 'Full name',
      document: 'Document',
      status: {
        recommended: 'NO FINDINGS',
        notRecommended: 'WITH FINDINGS',
        failed: 'FAILED',
      },
      buttons: {
        returnToPlatform: 'Return to SGRLOC platform',
        takeAnotherPhoto: 'Take another photo',
        backToStart: 'Back to start',
      },
    },
    optIn: {
      title: 'Terms of Use',
      checkboxText: 'I have read and agree to these terms and conditions',
      buttons: {
        accept: 'Accept',
        refuse: 'Decline',
      },
    },
    faceTecCamera: {
      back: 'back',
      titleCaptured: 'Captured photo',
      titleDefault: 'Photo',
      buttons: {
        clear: 'CLEAR',
        next: 'NEXT',
        startCamera: 'START CAMERA',
      },
      loadingCapture: 'Loading capture',
      capturedAlt: 'Captured photo',
    },
    loading: {
      alt: 'Loading...',
    },
    dropzone: {
      documentAlt: 'Document image',
      placeholder: 'Select your document',
      fileTooLarge: 'Maximum image size must be 1MB',
    },
    logos: {
      sgrLoc: 'SGRLoc logo',
      swint: 'Odeen logo',
    },
  },
};

export default en;
